  <!-- CREATE GIFT -->
  <div class="card-container">
    
    <form *ngIf="createForm" [formGroup]="createForm" class="mat-form">
    
    <mat-form-field appearance="outline" color="accent" >
      <mat-label>
        Fecha de inicio
      </mat-label>
        <input matInput [matDatepicker]="picker"  placeholder="17/08/2023"  formControlName="startDateOfEvent">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field appearance="outline" color="accent" >
      <mat-label>
        Fecha de culminación
      </mat-label>
      <input matInput [matDatepicker]="picker2" placeholder="24/08/2023" formControlName="dueDateOfEvent">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field appearance="outline" color="accent" class="form-group">
      <mat-label>Titulo</mat-label>
      <input type="text" matInput  placeholder="Cusica Fest" formControlName="fullName" />
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="form-group">
      <mat-label>Cantidad</mat-label>
      <input type="number" matInput  placeholder="Cusica Fest" formControlName="amount" />
    </mat-form-field>
    
    <!-- <button (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">😀</button>
          <br /><emoji-mart
          class="emoji-mart"
          *ngIf="isEmojiPickerVisible"
          (emojiSelect)="addEmojiToTitle($event)"
          title="Choose your emoji"
          ></emoji-mart> -->
    
      <mat-form-field appearance="outline" color="accent" class="form-group">
        <mat-label>Descripción</mat-label>
        <textarea matInput name="" id="" cols="30" 
        placeholder="Ven a compartir con todos tus amigos! No te pierdas la experiencia!"
        rows="10" formControlName="description" >

        </textarea>
      </mat-form-field>
      <!-- <button (click)="isEmojiPickerDescrVisible = !isEmojiPickerDescrVisible;">😀</button>
      <br /><emoji-mart
      class="emoji-mart"
      *ngIf="isEmojiPickerVisible"
      (emojiSelect)="addEmojiToDescription($event)"
      title="Choose your emoji"
      ></emoji-mart> -->
      <mat-form-field appearance="outline" color="accent" class="form-group">
        <mat-label>Codigo</mat-label>
        <input type="text" matInput placeholder="SAFAERA_CODE" formControlName="code" />
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent" class="form-group">
        <mat-label>Link de google maps</mat-label>
        <input type="text" matInput placeholder="https://maps.cr4.fre-er" formControlName="locationName" />
        <mat-error >
          El link debe ser google maps con la forma https://maps....
        </mat-error>
      </mat-form-field>

      <input style="visibility: hidden; height: 0px; width: 0;" type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
      <div class="page-form-image" style="display: flex; flex-flow: column; align-items: center; justify-content: center;" *ngIf="imageUrl">
          <img class="event-image"  [src]="imageUrl" alt="">
          <br>
          <button mat-icon-button (click)="deleteImage()">
              <mat-icon appearance="outline" color="accent" >delete_outline</mat-icon>
          </button>
          <br>
      </div>
          
      <div *ngIf="!imageUrl" style="text-align: center; margin-bottom: 24px;">
          <button style="border: 2px dotted; padding: 45px 25px;" (click)="selectFile(fileInput)" mat-button appearance="outline" color="accent" >
          <mat-icon>file_upload</mat-icon>
                  Cargar imagen
          </button>
      </div>
      <div class="row w-100 justify-center items-center">
        <button type="submit" [disabled]="!createForm?.valid" *ngIf="state=== 'create' || state === 'edit'" (click)="saveGiftChanges()" mat-raised-button color="primary">{{ state === 'create' ? 'Publicar': 'Editar'}}</button>
      </div>
    </form>

    <div class="loading-cdk" *ngIf="loading">
        <mat-spinner color="accent" diameter="40"></mat-spinner>
    </div>

  </div>